const INVALID_VALUE_TOKENS = new Set(['', 'nan', 'nat', 'null', 'undefined', 'none', 'n/a']);

function sanitizeValue(value) {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    if (INVALID_VALUE_TOKENS.has(trimmed.toLowerCase())) {
      return null;
    }
    return trimmed;
  }
  if (Array.isArray(value)) {
    return value
      .map((entry) => sanitizeValue(entry))
      .filter((entry) => entry !== null && entry !== undefined && !(typeof entry === 'string' && entry === ''));
  }
  if (typeof value === 'object') {
    const cleaned = {};
    Object.keys(value).forEach((key) => {
      const sanitized = sanitizeValue(value[key]);
      if (sanitized !== null && sanitized !== undefined && !(typeof sanitized === 'string' && sanitized === '')) {
        cleaned[key] = sanitized;
      }
    });
    return cleaned;
  }
  return null;
}

const BUYER_ANALYSIS_API_URL = window.location.hostname === 'localhost'
  ? 'http://127.0.0.1:8000/api/v1/buyer-analysis'
  : `${window.location.origin}/api/v1/buyer-analysis`;
console.log("Mpfadmopfasmpafsmoafs");
console.log(window.location.hostname);
async function fetchRealBuyerAnalysis(emailData, language, manualCustomerOverride = null) {
  try {
    const controller = new AbortController();
    // const timeoutId = setTimeout(() => controller.abort(), 45000);

    console.log('🔄 Iniciando análise via API...');

    const response = await fetch(`${BUYER_ANALYSIS_API_URL}/from-data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        itemId: emailData.itemId || '',
        internetMessageId: emailData.internetMessageId || '',
        subject: emailData.subject || '',
        body: emailData.body || '',
        sender: typeof emailData.sender === 'string' ? { email: emailData.sender } : emailData.sender || {},
        displayName: emailData.displayName || '',
        dateReceived: emailData.dateReceived || '',
        recipients: emailData.recipients || [],
        cc_recipients: emailData.cc_recipients || [],
        conversationId: emailData.conversationId || '',
        thread_context: emailData.thread_context || '',
        attachments: emailData.attachments || [],
        attachments_context: emailData.attachments_context || '',
        language: language || 'PT',
        manual_customer_override: manualCustomerOverride || null
      }),
      signal: controller.signal
    });

    // clearTimeout(timeoutId);

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      console.error(`❌ API Error ${response.status}:`, errorText);
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ Análise recebida com sucesso');
    return transformApiResponse(data);
  } catch (error) {
    if (error.name === 'AbortError') {
      console.error('⏱️ Timeout na chamada da API (45s)');
      throw new Error('A análise está demorando muito. Tente novamente.');
    } else {
      console.error('❌ Falha na análise:', error.message);
      throw error;
    }
  }
}

async function fetchCachedBuyerAnalysis(internetMessageId) {
  const messageId = String(internetMessageId || '').trim();
  if (!messageId) {
    return null;
  }
  let data;
  try {
    const response = await fetch(
      `${BUYER_ANALYSIS_API_URL}/cache?message_id=${encodeURIComponent(messageId)}`,
      { headers: { 'Accept': 'application/json' } }
    );
    if (!response.ok) {
      console.log(`⚠️ Cache de pré-análise indisponível (${response.status})`);
      return null;
    }
    data = await response.json();
  } catch (error) {
    console.log('⚠️ Erro ao consultar cache de pré-análise:', error.message);
    return null;
  }

  if (data.status === 'ready' && data.analysis) {
    console.log(`✅ Pré-análise encontrada (fonte: ${data.source || 'preanalysis'})`);
    return transformApiResponse(data.analysis);
  }
  console.log(`ℹ️ Sem pré-análise pronta (status: ${data.status}); a correr análise ao vivo`);
  return null;
}

async function searchBuyerCustomers(query, limit = 5) {
  const cleanQuery = String(query || '').trim();
  if (cleanQuery.length < 2) {
    throw new Error('Introduza pelo menos 2 caracteres para pesquisar.');
  }

  const response = await fetch(`${BUYER_ANALYSIS_API_URL}/customer-search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      query: cleanQuery,
      limit: limit || 5
    })
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    console.error(`❌ Customer Search API Error ${response.status}:`, errorText);
    throw new Error(`API Error: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  return Array.isArray(data.customers) ? data.customers : [];
}

function stripAttachmentPayloads(attachments) {
  if (!Array.isArray(attachments)) {
    return [];
  }
  return attachments.map((attachment) => {
    if (!attachment || typeof attachment !== 'object') {
      return {};
    }
    const {
      contentBase64,
      content_base64,
      base64,
      content,
      ...safeAttachment
    } = attachment;
    return safeAttachment;
  });
}

function buildSuggestionEmailPayload(emailData, analysis, language) {
  const rawRow = analysis?.rawAnalysisRow || {};
  return {
    itemId: emailData?.itemId || rawRow.email_id || '',
    subject: emailData?.subject || rawRow.subject || '',
    body: emailData?.body || rawRow.body_full || rawRow.body_preview || '',
    sender: typeof emailData?.sender === 'string' ? { email: emailData.sender } : emailData?.sender || rawRow.sender || {},
    displayName: emailData?.displayName || '',
    dateReceived: emailData?.dateReceived || rawRow.received_at || '',
    recipients: emailData?.recipients || rawRow.recipients || [],
    cc_recipients: emailData?.cc_recipients || rawRow.cc_recipients || [],
    conversationId: emailData?.conversationId || '',
    thread_context: emailData?.thread_context || rawRow.thread_context || '',
    attachments: stripAttachmentPayloads(emailData?.attachments || rawRow.attachments || []),
    attachments_context: rawRow.attachments_context || emailData?.attachments_context || '',
    language: language || 'PT'
  };
}

function buildSuggestionAnalysisRow(analysis) {
  const rawRow = analysis?.rawAnalysisRow || {};
  const analysisRow = {
    ...rawRow,
    email_suggestion: null,
    attachments: stripAttachmentPayloads(rawRow.attachments || [])
  };
  return sanitizeValue(analysisRow) || {};
}

async function generateBuyerEmailSuggestion(emailData, analysis, language) {
  if (!analysis?.isOrder) {
    throw new Error('A resposta só pode ser gerada para emails classificados como ordem.');
  }

  const response = await fetch(`${BUYER_ANALYSIS_API_URL}/generate-suggestion`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      email: buildSuggestionEmailPayload(emailData, analysis, language),
      analysis_row: buildSuggestionAnalysisRow(analysis),
      language: language || 'PT'
    })
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    console.error(`❌ Suggestion API Error ${response.status}:`, errorText);
    throw new Error(`API Error: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  const suggestion = data.email_suggestion || null;
  if (!suggestion || (!suggestion.subject && !suggestion.body)) {
    throw new Error('Não foi possível gerar uma resposta para esta análise.');
  }

  return {
    subject: suggestion.subject || null,
    body: suggestion.body || null,
    language: suggestion.language || language || null,
    tone: suggestion.tone || null,
    reasoning: suggestion.reasoning || null
  };
}

function transformApiResponse(apiData) {
  const rows = apiData.rows || [];

  if (rows.length === 0) {
    throw new Error('Nenhum dado retornado pela API');
  }

  const row = rows[0];
  const buyerInfo = row.identified_buyer || {};
  const orderAnalysis = row.order_analysis || {};
  const orderSignals = orderAnalysis.order_signals || {};
  const ambiguities = row.ambiguity_analysis || {};
  const history = row.buyer_history || {};
  const ambiguityDetected = ambiguities.needs_clarification || false;

  const transformed = {
    emailId: row.email_id,
    isOrder: orderAnalysis.is_order || false,
    orderConfidence: orderAnalysis.confidence || 0,

    buyer: {
      found: row.buyer_found_in_db || false,
      foundInDb: row.buyer_found_in_db || false,
      id: buyerInfo.buyer_id || buyerInfo.buyer_email,
      name: buyerInfo.buyer_name || 'Não identificado',
      email: buyerInfo.buyer_email || '',
      organization: buyerInfo.organization || '',
      source: buyerInfo.source || row.buyer_history_source || 'unknown'
    },

    orderDetails: {
      products: row.products || orderSignals.products || [],
      quantities: row.quantities || orderSignals.quantities || [],
      prices: row.prices || orderSignals.prices || orderSignals.precos || orderSignals['preços'] || orderSignals.price || orderSignals.preco || [],
      priceDisplays: orderSignals.prices_display || orderSignals.price_display || orderSignals.price_labels || orderSignals.prices_labels || [],
      dates: row.dates || orderSignals.dates || [],
      dateDisplays: orderSignals.dates_display || orderSignals.datesDisplay || [],
      references: row.references || orderSignals.references || [],
      observationNotes: orderSignals.observation_notes || orderSignals.observationNotes || orderSignals.observations || orderSignals.notes || [],
      materialCodes: row.material_codes || orderSignals.material_codes || orderSignals.materialCodes || [],
      materialDescriptions: row.material_descriptions || orderSignals.material_descriptions || orderSignals.materialDescriptions || [],
      reasoning: orderAnalysis.reasoning || '',
      validationResults: row.validation_results || orderAnalysis.validation_results || null,
      validation_results: row.validation_results || orderAnalysis.validation_results || null
    },

    ambiguities: {
      hasAmbiguities: ambiguityDetected,
      issues: (ambiguities.ambiguities || []).map(amb => ({
        type: amb.issue || 'Desconhecido',
        evidence: amb.evidence || '',
        action: amb.recommended_action || ''
      })),
      summary: ambiguities.summary || ''
    },

    buyerHistory: (() => {
      if (!history || typeof history !== 'object' || Object.keys(history).length === 0) {
        return null;
      }

      const isValidValue = (val) => {
        if (val === null || val === undefined) return false;
        if (typeof val === 'string') {
          const trimmed = val.trim();
          return trimmed !== '' && trimmed !== 'NaT' && trimmed !== 'nan' &&
            trimmed !== 'NaN' && trimmed !== 'null' && trimmed !== 'undefined';
        }
        if (typeof val === 'number') {
          return !isNaN(val);
        }
        return true;
      };

      const hasAnyData = Object.keys(history).some(key => {
        const value = history[key];
        return isValidValue(value);
      });

      if (!hasAnyData) {
        return null;
      }

      return {
        hasHistory: true,
        source: row.buyer_history_source || 'dynamodb',
        foundInDb: row.buyer_found_in_db || false,

        totalOrders: history['Item doc.vendas'] || history['item_doc_vendas'] || null,
        lastOrderDate: history['Data confirmação'] || history['Data do pedido'] || history['data_confirmacao'] || history['data_do_pedido'] || null,
        orderNumber: history['Nº do pedido'] || history['no_do_pedido'] || null,
        material: history['Material'] || history['material'] || null,
        materialCode: history['Material'] || history['material'] || null,
        quantity: history['Quantidade da ordem'] || history['quantidade_da_ordem'] || history['Qtd.confirmada'] || history['qtd_confirmada'] || null,
        quantityConfirmed: history['Qtd.confirmada'] || history['qtd_confirmada'] || null,
        quantityProduction: history['Qtd. Produção'] || history['qtd_producao'] || null,
        quantityPending: history['Quantidade Pendente Exp.'] || history['quantidade_pendente_exp'] || null,

        status: history['Status Confim. Encomenda'] || history['status_confim_encomenda'] || null,
        statusProduction: history['Status Ord. Produção'] || history['status_ord_producao'] || null,
        statusCredit: history['Status global créd.'] || history['status_global_cred'] || null,

        deliveryDate: history['Data prometida ao cliente'] || history['data_prometida_ao_cliente'] || null,
        materialPrepDate: history['Data prep.material'] || history['data_prep_material'] || null,
        startDate: history['Data-base do início'] || history['data_base_do_inicio'] || null,
        orderDate: history['Data do pedido'] || history['data_do_pedido'] || null,

        country: history['País Emissor Ordem'] || history['pais_emissor_ordem'] || null,
        orderIssuer: history['Emissor Ordem'] || history['emissor_ordem'] || null,
        orderIssuerName: history['Nome Emissor Ordem'] || history['nome_emissor_ordem'] || null,

        treatmentType: history['Tipo Tratamento'] || null,
        treatmentText: history['Pop-Up Texto Tipo Tratamento'] || null,
        markingType: history['Tipo Marcação'] || null,

        salesPerson: history['Responsavel Vendas VE'] || history['responsavel_vendas_ve'] || null,
        salesPersonName: history['Nome Responsavel Vendas VE'] || history['nome_responsavel_vendas_ve'] || null,
        orientador: history['Orientador'] || null,

        pk: history['pk'] || null,
        sk: history['sk'] || null,
        documentNumber: history['Documento de vendas'] || history['documento_de_vendas'] || null,

        productionOrder: history['Ordem de Produção'] || history['ordem_de_producao'] || null,
        deviationReason: history['Motivo de desvio'] || history['motivo_de_desvio'] || null,
        deviationText: history['Texto de motivo de desvio'] || history['texto_de_motivo_de_desvio'] || null,

        receiverCode: history['Recebedor Mercadoria'] || history['recebedor_mercadoria'] || null,
        receiverName: history['Nome Recebedor Mercadoria'] || history['nome_recebedor_mercadoria'] || null,

        price: history['Preço Prod./Mil'] || history['preco_prod_mil'] || null,
        netPrice: history['Preço líquido'] || history['preco_liquido'] || null,
        netValue: history['Valor Liquido Item'] || history['valor_liquido_item'] || null,
        userStatus: history['Status do usuário'] || history['status_do_usuario'] || null,
        globalStatus: history['Status global'] || history['status_global'] || null,

        itemCategory: history['Categoria do item'] || history['categoria_do_item'] || null,
        distributionChannel: history['Canal distribuição'] || history['canal_distribuicao'] || null,
        clientConfirmation: history['Conf. Cliente'] || history['conf_cliente'] || null,
        shippingStatus: history['Status de remessa'] || history['status_de_remessa'] || null,

        materialDescription: history['Texto breve material'] || history['texto_breve_material'] || history['Denominação'] || history['denominacao'] || null,
        clientMaterialNumber: history['Nº material do cliente'] || history['no_material_do_cliente'] || null,
        clientHierarchy: history['Hierarquia Cliente'] || null,

        topMark1: history['Marca 1º Topo'] || null,
        topMark2: history['Marca 2º Topo'] || null,
        topMark1Plus2: history['Marca Topo 1+2'] || null,
        bodyMark: history['Marca Corpo'] || null,
        bodyMarkCode: history['Marca Código Corpo'] || null,
        showMarks: history['Mostrar Marcas'] || null,
        commercialPopup: history['Pop-Up Texto Comercial'] || null,

        preLotCollectionDate: history['Data recolha pre-lotes'] || null,
        externalLabDate: history['Data Laboratório Externo'] || null,
        clientRequiredDate: history['Data Requerida Cliente'] || null,
        cqvDate: history['Data CQV'] || null,

        raw: history
      };
    })(),

    emailInfo: {
      subject: row.subject || '',
      sender: row.sender || {},
      recipients: row.recipients || [],
      ccRecipients: row.cc_recipients || [],
      receivedAt: row.received_at || null,
      threadContext: row.thread_context || null,
      bodyPreview: row.body_preview || null
    },

    customer: {
      name: row.customer_name || null,
      company: row.customer_company || null
    },
    customerSapCode: row.customer_sap_code || null,
    csiDocument: row.csi_document || null,
    salesforceOrder: row.salesforce_order || null,

    searchHints: row.search_hints || null,

    emailSuggestion: row.email_suggestion ? {
      subject: row.email_suggestion.subject || null,
      body: row.email_suggestion.body || null,
      language: row.email_suggestion.language || null,
      tone: row.email_suggestion.tone || null,
      reasoning: row.email_suggestion.reasoning || null
    } : (console.log('⚠️ row.email_suggestion está vazio ou null'), null),

    buyerHistoryOrders: row.buyer_history_orders || [],
    buyerHistoryIdentifier: row.buyer_history_identifier || null,
    buyerCandidates: (row.buyer_candidates || []).map(candidate => ({
      id: candidate.id,
      displayName: candidate.display_name || candidate.displayName || candidate.id || 'Nome desconhecido',
      source: candidate.source,
      score: candidate.score,
      selected: candidate.selected || false,
      selectionReason: candidate.selection_reason || candidate.selectionReason,
      selectionConfidence: candidate.selection_confidence || candidate.selectionConfidence,
      sapCountry: candidate.sap_country || candidate.sapCountry,
      countryAlignment: candidate.country_alignment || candidate.countryAlignment,
      reasons: candidate.reasons || [],
      matches: candidate.matches || [],
      emails: candidate.emails || [],
      domains: candidate.domains || [],
      organization: candidate.organization
    })),
    historyStats: row.history_stats || null,
    historyMatch: row.history_match_analysis || null
  };

  const sanitized = sanitizeValue(transformed) || {};
  const sanitizedBuyer = sanitized.buyer || {};
  const sanitizedOrderDetails = sanitized.orderDetails || {};
  const sanitizedAmbiguities = sanitized.ambiguities || {};
  const sanitizedEmailInfo = sanitized.emailInfo || {};
  const sanitizedCustomer = sanitized.customer || {};
  const sanitizedBuyerHistory = sanitized.buyerHistory;
  const sanitizedSearchHints = sanitized.searchHints;
  const ensureArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined) return [];
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed ? [trimmed] : [];
    }
    if (typeof value === 'number') {
      return Number.isNaN(value) ? [] : [value];
    }
    return [];
  };

  const sanitizedEmailSuggestion = (() => {
    if (!sanitized.emailSuggestion || typeof sanitized.emailSuggestion !== 'object') {
      console.log('⚠️ emailSuggestion ausente ou inválido após sanitização');
      return null;
    }
    const hasContent = sanitized.emailSuggestion.subject || sanitized.emailSuggestion.body;
    if (!hasContent) {
      console.log('⚠️ emailSuggestion não tem subject nem body após sanitização');
      return null;
    }
    console.log('✅ emailSuggestion válido após sanitização:', {
      hasSubject: !!sanitized.emailSuggestion.subject,
      hasBody: !!sanitized.emailSuggestion.body
    });
    return sanitized.emailSuggestion;
  })();

  const sanitizedBuyerCandidates = Array.isArray(sanitized.buyerCandidates) ? sanitized.buyerCandidates : [];
  const sapNumber =
    sanitized.customerSapCode ||
    transformed.customerSapCode ||
    sanitizedBuyerHistory?.orderIssuer ||
    sanitizedBuyerHistory?.raw?.['Emissor Ordem'] ||
    'N/A';

  return {
    emailId: sanitized.emailId || transformed.emailId || null,
    isOrder: Boolean(sanitized.isOrder),
    orderConfidence: typeof sanitized.orderConfidence === 'number' && !Number.isNaN(sanitized.orderConfidence) ? sanitized.orderConfidence : 0,

    buyer: {
      found: Boolean(sanitizedBuyer.found),
      foundInDb: Boolean(sanitizedBuyer.foundInDb),
      id: sanitizedBuyer.id || null,
      name: sanitizedBuyer.name || 'Não identificado',
      email: sanitizedBuyer.email || '',
      organization: sanitizedBuyer.organization || '',
      source: sanitizedBuyer.source || 'unknown'
    },

    orderDetails: {
      products: ensureArray(sanitizedOrderDetails.products),
      quantities: ensureArray(sanitizedOrderDetails.quantities),
      prices: ensureArray(sanitizedOrderDetails.prices),
      priceDisplays: ensureArray(sanitizedOrderDetails.priceDisplays),
      dates: ensureArray(sanitizedOrderDetails.dates),
      dateDisplays: ensureArray(sanitizedOrderDetails.dateDisplays),
      references: ensureArray(sanitizedOrderDetails.references),
      observationNotes: ensureArray(sanitizedOrderDetails.observationNotes || sanitizedOrderDetails.observation_notes || sanitizedOrderDetails.observations || sanitizedOrderDetails.notes),
      materialCodes: ensureArray(sanitizedOrderDetails.materialCodes),
      materialDescriptions: ensureArray(sanitizedOrderDetails.materialDescriptions),
      reasoning: sanitizedOrderDetails.reasoning || '',
      validationResults: sanitizedOrderDetails.validationResults || sanitizedOrderDetails.validation_results || null,
      validation_results: sanitizedOrderDetails.validationResults || sanitizedOrderDetails.validation_results || null
    },

    ambiguities: {
      hasAmbiguities: Boolean(sanitizedAmbiguities.hasAmbiguities),
      issues: Array.isArray(sanitizedAmbiguities.issues) ? sanitizedAmbiguities.issues : [],
      summary: sanitizedAmbiguities.summary || ''
    },

    buyerHistory: sanitizedBuyerHistory && Object.keys(sanitizedBuyerHistory).length > 0 ? sanitizedBuyerHistory : null,
    sapNumber,

    emailInfo: {
      subject: sanitizedEmailInfo.subject || '',
      sender: sanitizedEmailInfo.sender || {},
      recipients: Array.isArray(sanitizedEmailInfo.recipients) ? sanitizedEmailInfo.recipients : [],
      ccRecipients: Array.isArray(sanitizedEmailInfo.ccRecipients) ? sanitizedEmailInfo.ccRecipients : [],
      receivedAt: sanitizedEmailInfo.receivedAt || null,
      threadContext: sanitizedEmailInfo.threadContext || null,
      bodyPreview: sanitizedEmailInfo.bodyPreview || null
    },

    customer: {
      name: sanitizedCustomer.name || null,
      company: sanitizedCustomer.company || null
    },
    customerSapCode: sanitized.customerSapCode || transformed.customerSapCode || null,
    csiDocument: sanitized.csiDocument || transformed.csiDocument || null,
    salesforceOrder: sanitized.salesforceOrder || transformed.salesforceOrder || null,

    searchHints: sanitizedSearchHints && typeof sanitizedSearchHints === 'object' && Object.keys(sanitizedSearchHints).length > 0 ? sanitizedSearchHints : null,
    emailSuggestion: sanitizedEmailSuggestion,

    buyerHistoryOrders: Array.isArray(sanitized.buyerHistoryOrders) ? sanitized.buyerHistoryOrders : [],
    buyerHistoryIdentifier: sanitized.buyerHistoryIdentifier || null,
    buyerCandidates: sanitizedBuyerCandidates.map((candidate) => ({
      id: candidate.id || null,
      displayName: candidate.displayName || 'Nome desconhecido',
      source: candidate.source || null,
      score: typeof candidate.score === 'number' && !Number.isNaN(candidate.score) ? candidate.score : null,
      selected: Boolean(candidate.selected),
      selectionReason: candidate.selectionReason || null,
      selectionConfidence: typeof candidate.selectionConfidence === 'number' && !Number.isNaN(candidate.selectionConfidence) ? candidate.selectionConfidence : null,
      sapCountry: candidate.sapCountry || null,
      countryAlignment: candidate.countryAlignment || null,
      reasons: Array.isArray(candidate.reasons) ? candidate.reasons : [],
      matches: Array.isArray(candidate.matches) ? candidate.matches : [],
      emails: Array.isArray(candidate.emails) ? candidate.emails : [],
      domains: Array.isArray(candidate.domains) ? candidate.domains : [],
      organization: candidate.organization || null
    })),
    historyStats: sanitized.historyStats || null,
    historyMatch: sanitized.historyMatch || null,
    rawAnalysisRow: row
  };
}

if (typeof window !== 'undefined') {
  window.fetchRealBuyerAnalysis = fetchRealBuyerAnalysis;
  window.fetchCachedBuyerAnalysis = fetchCachedBuyerAnalysis;
  window.searchBuyerCustomers = searchBuyerCustomers;
  window.generateBuyerEmailSuggestion = generateBuyerEmailSuggestion;
  window.transformApiResponse = transformApiResponse;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    fetchRealBuyerAnalysis,
    fetchCachedBuyerAnalysis,
    searchBuyerCustomers,
    generateBuyerEmailSuggestion,
    transformApiResponse
  };
}
